import { connect } from 'react-redux'
import { actions } from '@opallabs/wormhole'
import loadBudget from '../utils/loadBudget'
import BudgetPanelManager from '.'

const mapStateToProps = (state, props) => ({
  budget: loadBudget({ state, id: props.id, context: props.context }),
})

const mapDispatchToProps = (dispatch) => ({
  getBudget: (options) => {
    dispatch(actions.getBudget(options))
  },
})

const ConnectedBudgetPanel = connect(
  mapStateToProps,
  mapDispatchToProps
)(BudgetPanelManager)

export default ConnectedBudgetPanel
